import { combineReducers } from 'redux';
import optimizationFormReducer from './optimizationFormReducer'
import loginUserReducer from './loginReducer';
import dateReducer from './dateReducer';

const rootReducer = combineReducers({
    finalReducers: optimizationFormReducer,loginUserReducer,dateReducer
});

export default rootReducer;